export const LAST_ACTIVITY_KEY = "healink:staff:lastActivityAt";

export const readLastActivity = () => {
  try {
    const ts = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY) || "", 10);
    return Number.isFinite(ts) ? ts : 0;
  } catch {
    return 0;
  }
};

export const writeLastActivity = (ts) => {
  try {
    localStorage.setItem(LAST_ACTIVITY_KEY, String(ts));
  } catch {
    return;
  }
};

export const clearLastActivity = () => {
  try {
    localStorage.removeItem(LAST_ACTIVITY_KEY);
  } catch {
    return;
  }
};
